import { controlledProductReportActions } from '../actions'

const {
  FETCHING_AREAS_LIST,
  FETCH_AREAS_LIST,
  FETCH_AREAS_LIST_ERROR,
  FETCHING_SUPERVISORIES_LIST,
  FETCH_SUPERVISORIES_LIST,
  FETCH_SUPERVISORIES_LIST_ERROR,
  FETCH_CONTROLLED_COMPONENTS,
  FETCHING_CONTROLLED_COMPONENTS,
  FETCH_CONTROLLED_COMPONENTS_ERROR,
  FETCH_CHANGE_AREAS,
  FETCH_CHANGE_CONTROLLED_COMPONENTS,
  FETCH_CHANGE_SUPERVISORIES,
  FETCH_DOWNLOAD_PDF,
  FETCHING_DOWNLOAD_PDF,
  FETCH_DOWNLOAD_PDF_ERROR,
  FETCH_DOWNLOAD_XLS,
  FETCHING_DOWNLOAD_XLS,
  FETCH_DOWNLOAD_XLS_ERROR,
} = controlledProductReportActions

const initialState = {
  fetching: {
    value: false,
    downloadPdf: false,
    downloadXls: false
  },
  areaList: [],
  controlledComponentList: [],
  supervisoriesList: [],
  selectedAreas: [],
  selectedControlledComponents: [],
  selectedSupervisories: [],
  fetch_errors: {
    value: false
  }
}

const controlledProductReport = (state = initialState, action = '') => {
  switch (action.type) {
    case FETCHING_AREAS_LIST:
      return { ...state, fetching: { ...state.fetching, value: action.value } }
    case FETCH_AREAS_LIST:
      return {
        ...state,
        areaList: action.items,
        fetching: {
          ...state.fetching,
          value: false
        }
      }
    case FETCH_AREAS_LIST_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          value: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          value: true
        }
      }
    case FETCH_CONTROLLED_COMPONENTS:
      return {
        ...state,
        controlledComponentList: action.items,
        fetching: { ...state.fetching, value: false },
        fetch_errors: {
          ...state.fetch_errors,
          value: false
        }
      }
    case FETCHING_CONTROLLED_COMPONENTS:
      return { ...state, fetching: { ...state.fetching, value: action.value } }
    case FETCH_CONTROLLED_COMPONENTS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          value: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          value: true
        }
      }
    case FETCH_SUPERVISORIES_LIST:
      return {
        ...state,
        supervisoriesList: action.items,
        fetching: { 
          ...state.fetching, 
          value: false 
        },
        fetch_errors: { 
          ...state.fetch_errors, 
          value: false 
        }
      }
    case FETCHING_SUPERVISORIES_LIST:
      return { 
        ...state, 
        fetching: { 
          ...state.fetching, 
          value: action.value 
        } 
      }
    case FETCH_SUPERVISORIES_LIST_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          value: false
        },
        fetch_errors: {
          ...state.fetch_errors,
          value: true
        }
      }
    case FETCH_CHANGE_AREAS:
      return {
        ...state,
        selectedAreas: action.areas
      }
    case FETCH_CHANGE_CONTROLLED_COMPONENTS:
      return {
        ...state,
        selectedControlledComponents: action.controlledComponents
      }
    case FETCH_CHANGE_SUPERVISORIES:
      return {
        ...state,
        selectedSupervisories: action.supervisories
      }
    case FETCH_DOWNLOAD_PDF:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadPdf: false
        }
      }
    case FETCHING_DOWNLOAD_PDF:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadPdf: true
        }
      }
    case FETCH_DOWNLOAD_PDF_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadPdf: false
        }
      }
    case FETCH_DOWNLOAD_XLS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadXls: false
        }
      }
    case FETCHING_DOWNLOAD_XLS:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadXls: true
        }
      }
    case FETCH_DOWNLOAD_XLS_ERROR:
      return {
        ...state,
        fetching: {
          ...state.fetching,
          downloadXls: false
        }
      }
    default:
      return state
  }
}


export default controlledProductReport



// WEBPACK FOOTER //
// ./src/reducers/controlledProductReport.js